// extracted by mini-css-extract-plugin
export var discard = "_43-3";
export var muiTooltipTooltip = "_43-5";
export var notificationBar = "_43-2";
export var saveButtonHoverSlotWrapper = "_43-4";
export var show = "_43-1";
export var spacer = "_43-0";